import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)

/**
 * HeadingColumnsSliderModule functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class HeadingColumnsSliderModule {
  /**
     * Constructs a new HeadingColumnsSliderModule instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-prev-btn"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-next-btn"]')
    this.columnSlides = this.element.querySelectorAll('.swiper-slide .column-slide')
    this.mediaQuery = window.matchMedia('(min-width: 1024px)')

    const headingColumnsSlider = new Swiper(this.swiperElement, {
      loop: false,
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 30,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      }
    })

    this.columnSlides.forEach((columnSlide) => {
      const hiddenText = columnSlide.querySelector('.hidden-text')
      const moreBtn = columnSlide.querySelector('.more-button .more')
      const lessBtn = columnSlide.querySelector('.more-button .less')
      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          this.swiperWrapper.style.height = 'auto'
          this.hideHiddenText(this.columnSlides)
          columnSlide.classList.add('show-hidden-text')
        })
      }
      if (lessBtn) {
        lessBtn.addEventListener('click', () => {
          this.hideHiddenText(this.columnSlides)
          headingColumnsSlider.updateAutoHeight()
          if (!document.body.classList.contains('single-treatment')) {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
            }
          } else {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
            }
          }
        })
      }
    })

    headingColumnsSlider.on('slideChange', () => {
      if (!document.body.classList.contains('single-treatment')) {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
        }
      } else {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
        }
      }
      this.hideHiddenText(this.columnSlides)
    })

  }

  hideHiddenText (columnSlides) {
    this.columnSlides.forEach((columnSlide) => {
      columnSlide.classList.remove('show-hidden-text')
    })
  }

}
